import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ButtonWithLabel from "app/popleads/components/ui-kit/ButtonWithLabel";
import { useExtensionContext } from "../ExtensionContext";
import { toast } from "react-toastify";
import useEditDeal from "app/popleads/hooks/useEditDeal";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import styled from "styled-components";
import moment from "moment";
import {
    POPUP_CONTENTS,
    publicTypes,
    DEAL_WON,
    DEAL_LOST,
    DEAL_CANCELLED,
    inHouseTypes,
    inquiryTypes,
    isCipdCampaign,
} from "../utils/constants";
import { useSelector } from "react-redux";

const StyledDealActions = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const DealFooter = () => {
    const {
        setState,
        modals,
        selectedDeal,
        isDealEditing,
        setIsDealEditing,
        dealObject,
        initialDealObject,
        setDealObject,
        createRegisterInHouseActivityURL,
        createRegisterELearningActivityURL,
        createActivityURL,
        refetchDeals,
        profile,
        validateCipdRequiredFields,
        cvAttachment,
        setCvAttachment,
        uploadDealCv,
    } = useExtensionContext();

    const { user: loggedInUser } = useSelector((state) => state.auth);
    const transferDealPermission =
        loggedInUser?.id === selectedDeal?.kayitciId || loggedInUser?.id === selectedDeal?.creatorUserId;

    const { editDeal, loading: editDealLoading } = useEditDeal();
    const isRegisteredDeal = selectedDeal?.invoiceRequisitionId || selectedDeal?.invoiceRequisitionActivityId;

    const willRegisterInHouseDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        (selectedDeal?.dealCampaignType === "In-house" ||
            selectedDeal?.dealCampaignType === "LVT In-House" ||
            selectedDeal.dealCampaignType === "Learning Journey") &&
        !isRegisteredDeal;

    const willRegisterELearningDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        (selectedDeal?.dealCampaignType === "E-Learning" || selectedDeal?.dealCampaignType === "EdTech") &&
        !isRegisteredDeal;

    const willRegisterConsultingDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        selectedDeal?.dealCampaignType === "Consulting" &&
        !isRegisteredDeal;

    const willRegisterCoachingDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        selectedDeal?.dealCampaignType === "Coaching" &&
        !isRegisteredDeal;

    const willCreateInvoiceRequisition =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum === DEAL_WON &&
        publicTypes.includes(selectedDeal?.dealCampaignType) &&
        !isRegisteredDeal;
    const disabledWillRegisterConsultingDeal =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum !== DEAL_WON &&
        !isRegisteredDeal &&
        (selectedDeal?.dealCampaignType === "Consulting" ||
            selectedDeal?.dealCampaignType === "Coaching" ||
            selectedDeal?.dealCampaignType === "E-Learning" ||
            selectedDeal?.dealCampaignType === "EdTech" ||
            selectedDeal?.dealCampaignType === "Learning Journey" ||
            selectedDeal?.dealCampaignType === "In-house" ||
            selectedDeal?.dealCampaignType === "LVT In-House");

    const disabledWillCreateInvoiceRequisition =
        !isDealEditing &&
        !editDealLoading &&
        selectedDeal?.durum !== DEAL_WON &&
        publicTypes.includes(selectedDeal?.dealCampaignType) &&
        !isRegisteredDeal;

    const handleCancelEdit = () => {
        setIsDealEditing(false);
    };

    const handleClick = async () => {
        if (!selectedDeal) return;

        if (willRegisterInHouseDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterInHouseActivityURL(profile?.id, dealObject);
            window.open(url, "_self");
        } else if (willRegisterELearningDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterELearningActivityURL(profile?.id, dealObject, "eLearning Confirmation");
            window.open(url, "_self");
        } else if (willRegisterConsultingDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterELearningActivityURL(profile?.id, dealObject, "Consulting Confirmation");
            window.open(url, "_self");
        } else if (willRegisterCoachingDeal) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createRegisterELearningActivityURL(profile?.id, dealObject, "Coaching Confirmation");
            window.open(url, "_self");
        } else if (willCreateInvoiceRequisition) {
            setState((prevState) => ({
                ...prevState,
                isRedirectingToDeal: true,
            }));
            const url = createActivityURL(selectedDeal.profilId, dealObject);
            window.open(url, "_self");
        } else if (isDealEditing) {
            const kapanmaTarihi = dealObject?.kapanmaTarihi || dealObject?.closingDate;

            if (!dealObject.amount) {
                toast.error("You need to enter the amount first");
                return true;
            }

            if (
                dealObject?.campaign?.type === "Public-ExEd" &&
                parseFloat(dealObject.amount) > parseFloat(dealObject.campaign.fullPrice)
            ) {
                toast.error("Deal amount can not be higher than campaign full price!");
                return false;
            }
            if (!dealObject.closingDate && [DEAL_WON, DEAL_LOST, DEAL_CANCELLED].includes(dealObject.status)) {
                toast.error("Please choose a closing date");
                return false;
            }
            if (!dealObject.type && dealObject.status === DEAL_WON) {
                toast.error("You need to enter the type first");
                return false;
            }

            if (!dealObject.accountName?.trim()) {
                toast.error("You need to enter an account name");
                return;
            }

            if (
                !dealObject.channelType &&
                ["Marketing", "Marketing Cross Sale"].includes(dealObject.type) &&
                dealObject.status === DEAL_WON
            ) {
                toast.error("Please select marketing channel");
                return false;
            }

            if (dealObject.dealCampaignType === "L&D Broker" && !dealObject.vendorPaymentAmount) {
                toast.error("Please enter amount for vendor payment");
                return;
            }
            if (dealObject.dealCampaignType === "L&D Broker" && !dealObject.leoronMarginAmount) {
                toast.error("Please enter margin amount for LEORON");
                return;
            }
            if (dealObject.type === "Re-Seller Partnership" && dealObject?.endUser?.length > 150) {
                toast.error("End User must be at most 150 characters");
                return;
            }

            if (dealObject.campaign && moment(kapanmaTarihi).year() !== moment(dealObject?.campaign?.basTarih).year()) {
                toast.error("Your closing date year must be the same as the campaign year");
                return;
            }
            // if (
            //     inHouseTypes.includes(dealObject?.dealCampaignType) &&
            //     dealObject?.courseName === "newCourseName" &&
            //     dealObject?.newCourseName === undefined
            // ) {
            //     toast.error("You need to enter new course name.");
            // }
            if (dealObject?.durum === DEAL_WON && publicTypes.includes(dealObject?.dealCampaignType)) {
                if (kapanmaTarihi && moment(kapanmaTarihi).year() !== moment(dealObject?.campaign?.basTarih).year()) {
                    toast.error("Your closing date year must be the same as the campaign year");
                    return;
                }

                if (
                    dealObject?.campaign?.type === "L&D Broker" ||
                    dealObject?.campaign?.type === "Public-ExEd" ||
                    dealObject?.campaign?.type === "Public - Certified Programs" ||
                    dealObject?.campaign?.type === "Public - Short Courses" ||
                    dealObject?.campaign?.type === "LVT Public - Certified Programs" ||
                    dealObject?.campaign?.type === "LVT Public - Short Courses"
                ) {
                    if (!dealObject.certificateName || dealObject.certificateName.trim() === "") {
                        toast.error("Please provide a certificate name");
                        return;
                    }
                    if (!dealObject.certificateLastName || dealObject.certificateLastName.trim() === "") {
                        toast.error("Please provide a certificate lastname");
                        return;
                    }
                }
            }

            if (
                dealObject?.durum === DEAL_WON &&
                (inHouseTypes.includes(dealObject?.dealCampaignType) ||
                    inquiryTypes.includes(dealObject?.dealCampaignType))
            ) {
                if (!dealObject?.courseName?.trim()) {
                    switch (dealObject.dealCampaignType) {
                        case "E-Learning":
                        case "EdTech":
                            toast.error("You need to select an e-learning bundles from the list.");
                            break;
                        case "Consulting":
                            toast.error("You need to select a consulting type from the list.");
                            break;
                        case "Coaching":
                            toast.error("You need to select a coaching type from the list.");
                            break;
                        default:
                            toast.error("You need to enter a course name");
                            break;
                    }
                    return;
                }

                if (dealObject?.courseName === "newCourseName") {
                    if (!dealObject?.newCourseName?.trim()) {
                        switch (dealObject.dealCampaignType) {
                            case "E-Learning":
                            case "EdTech":
                                toast.error("You need to enter new e-learning bundles.");
                                break;
                            case "Consulting":
                                toast.error("You need to enter new consulting type.");
                                break;
                            case "Coaching":
                                toast.error("You need to enter new coaching type.");
                                break;
                            default:
                                toast.error("You need to enter new course name.");
                                break;
                        }
                        return;
                    }
                }
            }

            // CIPD's own required-field checks (date of birth not in the future,
            // physical address, CV, installments) only ran on deal creation via
            // handleCreateDeal - editing a deal skipped them entirely, so a future
            // date of birth (or a missing CV, etc.) slipped through silently here.
            if (
                (dealObject.status === DEAL_WON || dealObject.durum === DEAL_WON) &&
                isCipdCampaign(dealObject.campaign) &&
                !validateCipdRequiredFields(dealObject)
            ) {
                return;
            }

            if (
                isCipdCampaign(dealObject.campaign) &&
                (dealObject.status === DEAL_WON || dealObject.durum === DEAL_WON) &&
                !String(dealObject.membership || "").trim()
            ) {
                toast.error("Membership is required.");
                return;
            }

            try {
                let dealObjectToSave = dealObject;
                // A newly-dropped CV file sits in `cvAttachment` (see ExtensionDealAttachments'
                // onFilesChange) but was never actually uploaded anywhere - only deal creation
                // did that, via uploadDealFilesForActivity. Editing has to do the same: upload
                // it first and carry the resulting attachmentId into the olanakGuncelle payload,
                // otherwise the edit silently keeps whatever CV (or lack of one) was already
                // stored.
                if (isCipdCampaign(dealObject.campaign) && cvAttachment?.length > 0) {
                    const res = await uploadDealCv({ files: cvAttachment });
                    if (res.error) {
                        toast.error(res.error || "Failed to upload CV attachment");
                        return;
                    }
                    const cvAttachmentId =
                        res?.data?.cvAttachmentId ||
                        res?.data?.attachmentId ||
                        res?.data?.cvAttachment?.id ||
                        res?.data?.cvAttachment?.attachmentId ||
                        res?.data?.id;
                    if (!cvAttachmentId) {
                        toast.error("CV attachment could not be uploaded.");
                        return;
                    }
                    dealObjectToSave = { ...dealObject, cvAttachmentId };
                }

                await editDeal(dealObjectToSave);
                setCvAttachment([]);
                //await refetchProfile();
                await refetchDeals();
                toast.success("Deal updated successfully");
                setIsDealEditing(false);
                //setSelectedDeal(null);
            } catch (error) {
                toast.error(error || "Failed to update deal");
            }
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <StyledDealActions>
                {!isDealEditing && (
                    <>
                        <OverlayTrigger placement="top" overlay={<Tooltip>Create New Potential</Tooltip>}>
                            <span>
                                <ButtonWithLabel
                                    variant="l3rnTech"
                                    buttonStyle="default"
                                    size="circle"
                                    icon={"add"}
                                    iconType={"material"}
                                    onClick={() => {
                                        setState((prevState) => ({
                                            ...prevState,
                                            popupContent: POPUP_CONTENTS.NEW_DEAL,
                                            popupIsOpen: true,
                                        }));
                                        setDealObject(initialDealObject);
                                    }}
                                />
                            </span>
                        </OverlayTrigger>
                        {selectedDeal && (
                            <>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Edit Deal</Tooltip>}>
                                    <ButtonWithLabel
                                        variant="l3rnTech"
                                        buttonStyle="default"
                                        size="circle"
                                        icon={"edit"}
                                        iconType={"material"}
                                        onClick={() => {
                                            setIsDealEditing(true);
                                        }}
                                    />
                                </OverlayTrigger>
                                {transferDealPermission && (
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Transfer Deal</Tooltip>}>
                                        <span>
                                            <ButtonWithLabel
                                                variant="l3rnTech"
                                                buttonStyle="default"
                                                size="circle"
                                                icon={"move_up"}
                                                iconType={"material"}
                                                onClick={() =>
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        popupContent: POPUP_CONTENTS.TRANSFER_DEAL,
                                                        popupIsOpen: true,
                                                    }))
                                                }
                                            />
                                        </span>
                                    </OverlayTrigger>
                                )}
                                <OverlayTrigger placement="top" overlay={<Tooltip>Create An Another Deal</Tooltip>}>
                                    <ButtonWithLabel
                                        variant="l3rnTech"
                                        buttonStyle="default"
                                        size="circle"
                                        icon={"content_copy"}
                                        iconType={"material"}
                                        onClick={() => {
                                            if (selectedDeal) {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    popupContent: POPUP_CONTENTS.NEW_DEAL,
                                                    popupIsOpen: true,
                                                    selectedCampaignStartDate: selectedDeal.kapanmaTarihi || new Date(),
                                                }));
                                                setDealObject({
                                                    ...dealObject,
                                                    courseName: null,
                                                    paidAmount: "0",
                                                    amount: null,
                                                    certificateName: "",
                                                    certificateLastName: "",
                                                    createAnotherDeal: true,
                                                });
                                            }
                                        }}
                                    />
                                </OverlayTrigger>

                                <OverlayTrigger placement="top" overlay={<Tooltip>Delete Deal</Tooltip>}>
                                    <ButtonWithLabel
                                        variant="danger"
                                        buttonStyle="default"
                                        size="circle"
                                        icon={"delete"}
                                        iconType={"material"}
                                        onClick={() => {
                                            if (selectedDeal?.durum === "Won") {
                                                setState({ selectedModal: modals.DELETE_BASED_ON_STATUS });
                                            } else {
                                                setState({ selectedModal: modals.DELETE_DEAL });
                                            }
                                        }}
                                    />
                                </OverlayTrigger>
                            </>
                        )}
                    </>
                )}
            </StyledDealActions>
            <div style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "center" }}>
                {isDealEditing && (
                    <ButtonWithText
                        variant="danger"
                        disabled={editDealLoading}
                        buttonStyle="borderless"
                        size="small"
                        onClick={handleCancelEdit}
                    >
                        Cancel
                    </ButtonWithText>
                )}
                {(disabledWillRegisterConsultingDeal || disabledWillCreateInvoiceRequisition) && (
                    <ButtonWithText
                        variant="warning"
                        buttonStyle="default"
                        type="default"
                        size="small"
                        disabled={editDealLoading}
                        onClick={() => toast.warning("You need to set the deal WON.")}
                    >
                        {disabledWillRegisterConsultingDeal
                            ? "Register Deal"
                            : disabledWillCreateInvoiceRequisition
                            ? "Create Invoice Requisition"
                            : ""}
                    </ButtonWithText>
                )}
                {(isDealEditing ||
                    willRegisterInHouseDeal ||
                    willRegisterELearningDeal ||
                    willRegisterConsultingDeal ||
                    willRegisterCoachingDeal ||
                    willCreateInvoiceRequisition) && (
                    <ButtonWithText
                        loading={isDealEditing && editDealLoading}
                        variant="l3rnTech"
                        buttonStyle="default"
                        type="default"
                        size="small"
                        disabled={editDealLoading}
                        onClick={handleClick}
                    >
                        {willRegisterCoachingDeal ||
                        willRegisterInHouseDeal ||
                        willRegisterELearningDeal ||
                        willRegisterConsultingDeal
                            ? "Register Deal"
                            : willCreateInvoiceRequisition
                            ? "Create Invoice Requisition"
                            : "Save"}
                    </ButtonWithText>
                )}
            </div>
        </div>
    );
};
